import styled, { css } from 'styled-components';
import { Button } from '../../button';
import { DropdownTriggerButton } from '../../dropdown/trigger-button';
import { FontAwesomeIcon } from '../../icon/icon';

export const ToolbarButton = styled(Button).attrs({
  size: 'small',
  type: 'text',
})<{ $active?: boolean }>`
  ${({ $active }) =>
    $active
      ? css`
          background-color: var(--button-secondary-hover);
          border-color: var(--scarlet-gray-100);
        `
      : css``};
`;
export const ToolbarDropdownTriggerButton = styled(DropdownTriggerButton).attrs(
  {
    size: 'small',
  },
)``;
export const ToolbarButtonIcon = styled(FontAwesomeIcon).attrs({
  size: 12,
})``;
